var map = {
	"./about-us/banner.jpg": 5452,
	"./about-us/cert-1-img.png": 9334,
	"./about-us/cert-2-img.png": 1899,
	"./about-us/cert-3-img.png": 1261,
	"./about-us/cert-4-img.png": 1401,
	"./about-us/cert-5-img.png": 9054,
	"./about-us/cert-6-img.png": 2616,
	"./about-us/cert-7-img.png": 486,
	"./about-us/cert-8-img.png": 7322,
	"./about-us/core-values-cover.jpg": 8148,
	"./about-us/organization_chart.png": 4549,
	"./about-us/vision-cover.jpg": 2945,
	"./careers/cover-image.jpg": 628,
	"./company-logos/allo.png": 5743,
	"./company-logos/digi-backup.svg": 3242,
	"./company-logos/digi.svg": 2541,
	"./company-logos/jkr.svg": 3549,
	"./company-logos/ktm.svg": 6313,
	"./company-logos/maxis.svg": 3466,
	"./company-logos/sarawak.png": 7150,
	"./company-logos/sesb.svg": 1422,
	"./company-logos/tm.svg": 882,
	"./company-logos/tnb.svg": 5121,
	"./contact-us/cover-image.jpg": 2219,
	"./contact-us/deco-pole/pole-1-img.png": 4087,
	"./contact-us/deco-pole/pole-1-thumb.png": 6697,
	"./contact-us/deco-pole/pole-2-img.png": 3696,
	"./contact-us/deco-pole/pole-2-thumb.png": 1002,
	"./contact-us/deco-pole/pole-3-img.png": 2087,
	"./contact-us/deco-pole/pole-3-thumb.png": 4802,
	"./contact-us/deco-pole/slide-1.jpg": 7794,
	"./contact-us/deco-pole/slide-2.jpg": 8990,
	"./landing/decorative-pole.jpg": 7142,
	"./landing/intro-products.jpg": 3688,
	"./landing/landing.png": 8527,
	"./landing/malaysia-railway-poles.jpg": 8064,
	"./landing/open-positions-background.jpg": 8577,
	"./landing/prestressed-concrete.jpg": 2973,
	"./landing/slide-1.jpg": 5714,
	"./landing/slide-2.jpg": 1383,
	"./landing/slide-3.jpg": 4548,
	"./logo.png": 7919,
	"./products/concrete-pole/pole-1-img.png": 3724,
	"./products/concrete-pole/pole-2-img.png": 9933,
	"./products/concrete-pole/slide-2.jpg": 3971,
	"./products/concrete-pole/slide-3.png": 5471,
	"./products/cover-image.png": 2240,
	"./products/deco-pole/deco-pole.jpg": 4011,
	"./products/deco-pole/pole-1-img.png": 3913,
	"./products/deco-pole/pole-2-img.png": 1929,
	"./products/deco-pole/pole-3-img.png": 1353,
	"./products/malaysia-railway-pole/malaysia-railway-poles-1.jpg": 1321,
	"./products/malaysia-railway-pole/slide-1.png": 7617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;